var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('navbar',{attrs:{"id":"navbar"}})],1),_vm._v(" "),_c('main',[_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('tabBar')],1),_vm._v(" "),_c('footer',[_c('MunFooter',{attrs:{"id":"munFooter"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-377328f7","hasScoped":false,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index.vue
// module id = null
// module chunks = 